<template>
  <div class="flex flex-col">
    <div class="overflow-x-auto">
      <div class="inline-block w-full py-2 align-middle">
        <h1
          class="text-ontick-steel-900 py-2 text-lg font-medium dark:text-gray-300"
        >
          {{ title }}
        </h1>

        <div
          class="border-ontick-steel-300 dark:border-ontick-steel-600 overflow-hidden border-b shadow sm:rounded-lg"
        >
          <table
            class="divide-ontick-steel-300 dark:divide-ontick-steel-600 min-w-full divide-y"
          >
            <thead class="bg-ontick-steel-100 dark:bg-ontick-steel-600">
              <tr>
                <th
                  v-for="(item, index) in header"
                  :key="index"
                  scope="col"
                  class="title_th"
                >
                  <button
                    class="flex h-full w-full items-center justify-start space-x-1 text-left font-bold"
                    @click="sort(item.key)"
                  >
                    <span v-if="item.key === sortKey">
                      {{ sortIcon }}
                    </span>
                    <p>
                      {{ item.label }}
                    </p>
                  </button>
                </th>
              </tr>
            </thead>
            <transition-group
              v-on:enter="enter"
              v-on:leave="leave"
              v-bind:css="false"
              appear
              mode="out-in"
              tag="tbody"
              class="divide-ontick-steel-300 dark:divide-ontick-steel-600 dark:bg-ontick-graphite-500 divide-y bg-gray-50"
            >
              <tr
                class="dark:bg-ontick-graphite-500 bg-gray-50 text-gray-500 dark:text-gray-400"
                v-for="(item, index) in sortedData"
                :key="index"
                @click="selectedDetails(item)"
              >
                <td class="td-items flex items-center gap-2 text-gray-300">
                  <!-- <button v-if="item.type==='PORTFOLIO'"></button> -->
                  {{ item.strategy_name }}
                </td>
                <td class="td-items">
                  <span
                    class="bg-ontick-blue-900 rounded-sm px-1.5 font-semibold text-white"
                  >
                    {{ item.position_symbol }}
                  </span>
                </td>
                <td class="td-items">
                  <div class="flex items-center gap-1 font-semibold">
                    <span
                      class="bg-ontick-yellow-700 text-ontick-graphite-500 flex w-4 items-center justify-center rounded-sm"
                    >
                      {{ item.position_type.charAt(0) }}
                    </span>
                    <span class="text-gray-300">
                      {{ item.position_volume }}
                    </span>
                  </div>
                </td>
                <td class="td-items">
                  {{ item.position_time | moment("DD/MM/YYYY HH:mm:ss:SSS") }}
                </td>
                <!-- <td class="td-items">
                  {{
                    item.position_type == "BUY" ||
                    item.position_type == "Comprado"
                      ? "Comprado"
                      : "Vendido"
                  }}
                </td> -->
                <!-- <td class="td-items">
                  {{ item.position_volume }}
                </td> -->

                <td class="td-items">
                  {{ item.position_price_avg }}
                </td>

                <td class="td-items">
                  {{ item.position_sl }}
                </td>
                <td class="td-items">
                  {{ item.position_tp }}
                </td>
                <!-- <td class="chart_stream">
                  <v-chart
                    autoresize
                    :options="
                      chartLine(item.chart, item.position_sl, item.position_tp)
                    "
                  ></v-chart>
                </td> -->
                <td class="td-items flex items-center gap-1">
                  <i
                    v-html="$icons.error"
                    v-if="connectionStatus.error"
                    content="Erro na conexão. Atualize a página para tentar novamente."
                    v-tippy="{ arrow: true, theme: 'red' }"
                  ></i>
                  <template v-else>
                    <i
                      v-html="$icons.loading"
                      v-if="
                        connectionStatus.awaitingConnection ||
                        item.adj_position_profit === null
                      "
                      class="text-ontick-blue-600"
                      :content="
                        spinnerTooltip(
                          connectionStatus.awaitingConnection,
                          item.adj_position_profit === null
                        )
                      "
                      v-tippy="{ arrow: true, theme: 'green' }"
                    ></i>
                    <i
                      v-else-if="item.adj_position_profit != 0"
                      :class="
                        item.adj_position_profit > 0
                          ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
                          : 'text-ontick-red-500 rotate-180'
                      "
                      v-html="$icons.arrow_drop"
                    ></i>
                    <span class="text-gray-300">
                      {{ item.adj_position_profit | currency }}
                    </span>
                  </template>
                </td>
                <td class="td-items">
                  {{ item.position_comment }}
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import DetailsStream from "./details.position.component.vue";

export default {
  props: {
    data: { type: Object, default: {} },
    title: { type: String, default: "Titulo" },
    connectionStatus: { type: Object },
  },
  components: {
    CollapseTransition,
    DetailsStream,
  },

  data() {
    return {
      header: [
        { label: "Estratégia", key: "strategy_name" },
        { label: "Ativo", key: "position_symbol" },
        { label: "Posição", key: "position_status" },
        { label: "Horário", key: "position_time" },
        // { label: "Tipo", key: "position_type" },
        // { label: "Volume", key: "position_volume" },
        { label: "Preço", key: "position_price" },
        { label: "SL", key: "position_sl" },
        { label: "TP", key: "position_tp" },
        { label: "Resultado", key: "adj_position_profit" },
        { label: "Comentário", key: "position_comment" },
      ],
      toogle: [],
      line: [],
      details: { active: false, strategy: {} },
      sortDirection: "",
      sortKey: "",
      expandedPortfolioIds: [],
    };
  },

  computed: {
    sortIcon() {
      const directions = {
        asc: "▲",
        desc: "▼",
      };
      return directions[this.sortDirection] || "";
    },
    sortedData() {
      switch (this.sortDirection) {
        case "asc":
          return this.data.investments.sort((a, b) => {
            if (a[this.sortKey] < b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] > b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        case "desc":
          return this.data.investments.sort((a, b) => {
            if (a[this.sortKey] > b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] < b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        default:
          return this.data.investments.sort((a, b) => {
            if (a.position_time > b.position_time) {
              return -1;
            } else if (a.position_time < b.position_time) {
              return 1;
            } else {
              return 0;
            }
          });
      }
    },
  },

  methods: {
    expandPortfolio(investment_id) {
      if (this.expandedPortfolioIds.includes(investment_id)) {
        this.expandedPortfolioIds.splice(
          this.expandedPortfolioIds.findIndex((item) => item == investment_id),
          1
        );
      } else {
        this.expandedPortfolioIds.push(investment_id);
      }
    },
    spinnerTooltip(awaitingConnection, awaitingData) {
      if (awaitingConnection) {
        return "Aguardando conexão...";
      } else if (awaitingData) {
        return "Aguardando dados atualizados...";
      }
    },
    sort(key) {
      if (key) {
        if (this.sortKey === key) {
          this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
        } else {
          this.sortDirection = "asc";
        }
        this.sortKey = key;
      }
    },
    enter(el, done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      tl.set(el, {
        x: window.innerWidth * 1.5,
        scale: 0.9,
        transformOrigin: "50% 50%",
      });

      tl.to(el, 0.5, {
        x: 0,
        ease: Power4.easeOut,
      });

      tl.to(el, 0.5, {
        scale: 1,
        ease: Power4.easeOut,
      });
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        0.5,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    selectedDetails(item) {
      this.details.active = true;
      this.details.strategy = item;
    },
    badgerStatus(value) {
      let color = "";
      if (value == "P") {
        color = "bg-ontick-blue-800 text-ontick-blue-200";
      } else if (value == "F") {
        color = "bg-ontick-lime-900 text-ontick-lime-400";
      } else if (value == "S") {
        color = "bg-ontick-teal-600 text-ontick text-ontick-teal-50";
      } else if (value == "W") {
        color = "bg-gray-600 text-gray-300";
      } else if (value == "C") {
        color = "bg-ontick-orange-900 text-ontick-orange-300";
      } else if (value == "R") {
        color = "bg-ontick-red-900 text-ontick-red-300";
      } else if (value == "E") {
        color = "bg-ontick-pink-900 text-ontick-link-300";
      } else if (value == "T") {
        color = "bg-ontick-yellow-800 text-ontick-yellow-50";
      }
      return color;
    },

    chartLine(value, sl, tp) {
      let option = {
        grid: {
          left: "0%",
          right: "20%",
          bottom: "20%",
          top: "20%",
        },
        xAxis: {
          show: false,
          type: "category",
          boundaryGap: false,
          axisLabel: {
            color: "rgba(255, 255, 255, 0.8)",
            fontSize: 10,
            show: false,
          },
          splitLine: {
            lineStyle: {
              show: false,
            },
            show: false,
          },

          axisLine: {
            symbol: "none",
          },
        },

        tooltip: {
          show: false,
        },

        yAxis: {
          type: "value",
          scale: true,

          axisLabel: { show: false },

          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          minorSplitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            data: value,
            symbol: "none",
            endLabel: {
              show: true,
              color: "#fff",
              // formatter: function (params) {
              //     // return params.value[3] + ': ' + params.value[0];
              // }
            },
            labelLayout: {
              moveOverlap: "shiftY",
            },
            markLine: {
              silent: true,
              data: [
                // { name: "TP", type: "average", yAxis: tp },
                // { name: "SL", type: "average", yAxis: sl },
                { yAxis: 125905, name: "tp" },
              ],
            },
          },
        ],
      };

      return option;
    },

    showInvestmentPortfolio(inv) {
      const index = this.toogle.indexOf(inv);
      if (index > -1) {
        this.toogle.splice(index, 1);
      } else {
        this.toogle.push(inv);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.title_th {
  @apply text-ontick-steel-900 px-3 py-2 text-left text-sm font-bold dark:text-gray-300;
}
.td-items {
  @apply whitespace-nowrap px-3 py-3 text-left text-xs;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.chart_stream {
  .echarts {
    height: 60px;
    width: 250px;
  }
}
</style>
